module.exports = __webpack_public_path__ + "img/Dogs-marker-gray.022b5e3d.svg";